import { render } from "./Instances.vue?vue&type=template&id=7aa1c78a&ts=true"
import script from "./Instances.vue?vue&type=script&lang=ts"
export * from "./Instances.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__